import { gbpeLoadedCheck } from '../portable-experiences'
import { parseTokenForEntitlements, getVerificationStatusFromToken } from '../auth/verify-token'

export class EntitlementService {
	private _entitlements: string[]
	private _verified: boolean
	private _isCelestiq: boolean
	public loaded = new Promise<void>(resolve => {
		gbpeLoadedCheck(async () => {
			if (window.gbpe.auth) {
				window.gbpe.auth.loaded.then(() => {
					this._fetchEntitlements()
					this._checkCelestiq()
					resolve()
				})
			}
		})
	})

	public get entitlements(): string[] {
		return this._entitlements
	}

	public get isCelestiq(): boolean {
		return this._isCelestiq
	}

	private _fetchEntitlements() {
		if (window.gbpe.auth.currentAuthState === 1 && window.gbpe.auth.idToken) {
			this._getEntitlementsFromToken(window.gbpe.auth.idToken)
		}
	}

	private _getEntitlementsFromToken(idToken: string) {
		const verifiedStatus = getVerificationStatusFromToken(idToken)
		const entitlement = parseTokenForEntitlements(idToken)
		this._verified = verifiedStatus ? true : false
		this._entitlements = entitlement ? this._convertToList(entitlement) : null
	}

	private _convertToList(entitlement) {
		return entitlement.split(',')
	}

	private _checkCelestiq() {
		const CELESTIQ_ENTITLEMENT = ['CELESTIQVIP', 'JDCONCIERGE']
		this._isCelestiq = this.entitlements
			? CELESTIQ_ENTITLEMENT.filter(item => this.entitlements.includes(item)).length > 0
				? true
				: false
			: false
	}
}
